import ProtectedRoute from "./components/auth/ProtectedRoute";
import React from "react";
import SubscribedUserLayout from "./layouts/SubscribedUser";
import UtilService from "./services/utilService";
import AdminLayout from "./layouts/Admin";
import Dashboard from "./views/pages/dashboards/Dashboard";
import Trends from "./views/pages/reviews/Trends";

const subscribedUserProtectedRoutes = [
    <ProtectedRoute key={UtilService.uuidv4()}
        requiredRoleList={["ROLE_FREE","ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/dashboard"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/auth/login"
        path="/user/settings"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/company/list"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/company/create"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/company/show/:uniqueId"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/company/edit/:uniqueId"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/contact/list"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/audience/list"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/contact/create"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/contact/show/:uniqueId"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/contact/edit/:uniqueId"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/trends"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_BASIC", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/unanswered"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_FREE","ROLE_BASIC","ROLE_STARTER", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/drive/my-drive"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_FREE","ROLE_BASIC","ROLE_STARTER", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/drive/my-drive/:uniqueId"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_FREE","ROLE_BASIC","ROLE_STARTER", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/drive/shared"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_FREE","ROLE_BASIC","ROLE_STARTER", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/drive/shared/:uniqueId"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
    <ProtectedRoute
        requiredRoleList={["ROLE_FREE","ROLE_BASIC","ROLE_STARTER", "ROLE_ADVANCE", "ROLE_PRO", "ROLE_BUISNESS"]}
        redirectToPath="/"
        path="/user/drive/shared/:uniqueId/folder/:folderId"
        component={(props) => <SubscribedUserLayout {...props} />}
    />,
]

export default subscribedUserProtectedRoutes;